import { SharedContent } from './shared-content';
export const ErrorContent = {
  inheritance: {
    contactusHeading: `We're unable to process your transfer at this time`,
    contactusDesc:
      'We apologize for any inconvenience, especially at a time like this. Please call Vanguard and one of our inheritance specialists can help you.',
  },
  living: {
    contactusHeading: `We're unable to process your transfer at this time`,
    contactusDesc:
      'We apologize for any inconvenience. Please call Vanguard and mention "change of ownership”, and one of our transfer specialists can help you.',
  },
  viewAccountsButtonLabel: 'View my accounts',
  cancelButtonLabel: 'Cancel',
  checklistHeading: SharedContent.checklistHeading,
  checklistDesc: SharedContent.checklistDesc,
  checklistBullets: SharedContent.checklistBullets,
  blockquoteHeading: SharedContent.blockquoteHeading,
  blockquoteText: SharedContent.blockquoteText,
};
